<template>
  <v-card>
    <v-card-title>Official Complaints</v-card-title>
    <!-- <v-card-text>Explanation of the graph?</v-card-text> -->
    <v-card-text class="text-center">
      <doughnut-chart v-if="complaintsloaded" :chartData="chartdata" :options="options" />
      <template v-else >
        <p>Loading data from server...</p>
        <v-progress-circular indeterminate size="100"/>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { get } from "vuex-pathify";
import DoughnutChart from "@/charts/DoughnutChart.vue"

export default {
  name: "OfficialComplaints",
  components: { DoughnutChart },
  data: function () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        // scales: {
        //   xAxes: [{
        //     stacked: true
        //   }],
        //   yAxes: [{
        //     stacked: true
        //   }]
        // }
      },
      chartdata: {
        labels: [],
        datasets: [],
      },
    };
  },
  async mounted() {
    await new Promise((resolve) => setTimeout(resolve, 400));
    this.fillData();
  },
  computed: {
    ...get("chart", ["complaints", "complaintsloaded"]),
  },
  methods: {
    fillData() {
      this.chartdata = {
        type: 'doughnut',
        labels: this.complaints.labels,
        datasets: [
          {
            label: 'check what is this?',
            data: this.complaints.series,
            // no - unknown - yes
            backgroundColor: [ '#404564','#dedfe4','#28afbb']
          },
        ] 
      }
    },
  },
};
</script>
